<div class="modal-header">
  <h5 class="modal-title">{{ title }}</h5>
  <button type="button" class="btn-close" [attr.aria-label]="'common.close' | transloco" (click)="closeModal()">
    <i class="ph ph-x"></i>
  </button>
</div>

<div class="modal-body">
  <div class="document-preview">
    @if (isImageLoading) {
      <span class="spinner-border text-secondary"></span>
    } @else if (hasDocument && !hasPreviewError) {
      <img [src]="previewUrl" [alt]="documentName" />
    } @else if (hasDocument && hasPreviewError) {
      <p class="modal-description">{{ 'compliance.shared.modals.documentView.previewUnavailable' | transloco }}</p>
    } @else {
      <p class="modal-description">{{ documentName || ('compliance.shared.modals.documentView.noDocumentAvailable' | transloco) }}</p>
    }
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="close-btn" (click)="closeModal()">{{ 'common.close' | transloco }}</button>
  <button type="button" class="download-btn" [disabled]="!hasDocument || isDownloading" (click)="onDownload()">
    @if (isDownloading) {
      <span class="spinner-border spinner-border-sm"></span>
    } @else {
      {{ 'compliance.shared.modals.documentView.download' | transloco }}
    }
  </button>
</div>
